import React from 'react';
import { useField } from 'formik';

import { TextInput } from '../shared/TextInput/TextInput';

export const FormikTextInput = ({ name, leftIcon, ...props }) => {
  const [field, meta] = useField(name);

  return (
    <TextInput
      {...field}
      {...props}
      name={name}
      leftIcon={leftIcon}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
